module.exports = __webpack_public_path__ + "img/traegheit.bc1d7c5a.png";